// extracted by mini-css-extract-plugin
module.exports = {"blocksContainer":"MainPage_blocksContainer__R_fOV"};